<template>
  <div class="muzik-game mk-container">
    <ul class="game-list">
      <li>
        <div class="game-grid">
          <RouterLink :to="{name: 'piano'}">
            <img src="@/assets/images/game/img-default.png" alt="Piano game">
          </RouterLink>
        </div>
      </li>
      <li>
        <div class="game-grid">
          <a href="https://event.muzik.com.tw/magazine/muzik133/">
            <img src="@/assets/images/game/MUZIK133_air_900x471.jpg" alt="MUZIK133_air">
          </a>
        </div>
      </li>
      <li>
        <div class="game-grid">
          <a href="https://event.muzik.com.tw/magazine/muzik132/">
            <img src="@/assets/images/game/MUZIK132_air_900x471.jpg" alt="MUZIK132_air">
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Game',
  props: {},
  data() {
    return {}
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    title() {
      // const productionName = this.$production.toUpperCase()
      const productionLocaleName = this.$t(`${this.$production.toUpperCase()}.TITLE`)
      return `${this.$t('GAME.TITLE')} | ${productionLocaleName} | MUZIK AIR`
    },
    cover() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const coverPath = this.$production.toLowerCase()
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
    },
    keywords() {
      return this.$t('GAME.TITLE')
    },
    canonicalURL() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`
    },
    structuredData() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const urlSubDomain = isAirProduction ? '' : `${process.env[subDomainKey]}.`
      const structuredData = {
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        '@id': this.canonicalURL,
        url: this.canonicalURL,
        image: this.cover,
        name: this.title,
        description: this.title,
        relatedLink: [
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/terms`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/about`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/mediaKit`
        ]
      }
      return structuredData
    },
    locale() {
      return this.$i18n.locale
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
  .game-list{
    position: relative;
    margin: 40px -1em;
    padding: 0;
    list-style: none;
    li{
      position: relative;
      display: inline-block;
      width: 50%;
      float: left;
      padding-top: 27.5%;
      overflow: hidden;
      margin-bottom: 1em;
      .game-grid{
        display: inline-block;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        padding: 1em;
      }
      a{
        display: inline-block;
        border: 1px solid #f5f5f5;
        width: 100%;
        height: 100%;
        background: #f5f5f5;
        text-align: center;
        img{
          height: 100%;
          width: auto;
        }
      }
    }
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  @media only screen and (max-width: 767.98px) {
    .game-list{
      margin: 40px 0;
      li{
        width: 100%;
        padding-top: 52%;
      }
    }
  }
</style>
